<script>
export default {
  name: 'TuneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="4" y1="6" x2="11" y2="6" />
      <line x1="17" y1="6" x2="20" y2="6" />
      <circle cx="14" cy="6" r="2.5" fill="none" />
      <line x1="4" y1="12" x2="5" y2="12" />
      <line x1="11" y1="12" x2="20" y2="12" />
      <circle cx="8" cy="12" r="2.5" fill="none" />
      <line x1="4" y1="18" x2="14" y2="18" />
      <line x1="20" y1="18" x2="20" y2="18" />
      <circle cx="17" cy="18" r="2.5" fill="none" />
    </g>
  </svg>
</template>
